import MainController from "../_base/main_controller";
export default class extends MainController {
    setUpForm(event) {
        super.setUpForm(event);
        if (this.model) {
            const form = this.form;
            form.elements["account[id]"].value = this.model.id.toString();
            const tomselect = this.form.elements["account[bank]"].tomselect;
            if (this.model.bankId) {
                tomselect.setValue(this.model.bankId.toString());
            }
            else {
                if (!tomselect.createItem(this.model.bankName)) {
                    tomselect.setValue(this.model.bankName);
                }
            }
            form.elements["account[name]"].value = this.model.name;
            form.elements["account[number]"].value = this.model.number;
        }
    }
    clearForm() {
        super.clearForm();
        this.form.elements["account[bank]"].tomselect.sync();
    }
    isFormValid() {
        return this.form.reportValidity();
    }
    getFormSubmitRequest() {
        return new Request(this.getFormSubmitUrl(), {
            method: "POST",
            body: new FormData(this.form),
        });
    }
}
//# sourceMappingURL=main_controller.js.map